module.exports = __webpack_public_path__ + "03fc2b62191cb0203677d2b434b9d801.svg";